<div>
  <form [formGroup]="emailForm">
    <div class="form-container">
      <div fxLayout="column">
        <mat-form-field
          *ngIf="
            isEmailTypeInvitee ||
            isEmailTypeInvitees ||
            isEmailTypeTeamMembers ||
            isEmailTypeInvitationReminder ||
            isEmailTypeBulk ||
            isEmailTypeSingle ||
            isEmailTypeWallCertificate
          "
          appearance="outline"
          floatLabel="always"
          fxFlex
        >
          <mat-label>Email template</mat-label>
          <mat-select
            formControlName="emailTemplate"
            placeholder="No template selected"
            (selectionChange)="emailTemplateSelected()"
          >
            <mat-option *ngFor="let template of emailTemplates" [value]="template">
              {{ template.templateName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always" fxFlex>
          <mat-label>From</mat-label>
          <input matInput forbidAngleBrackets class="from-name-input" type="text" formControlName="fromName" />
          <mat-error *ngIf="emailForm.get('fromName').hasError('required')"> From is required </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always" fxFlex>
          <mat-label>Reply to email</mat-label>
          <input matInput forbidAngleBrackets class="reply-to-input" type="text" formControlName="replyTo" />
          <mat-error *ngIf="emailForm.get('replyTo').hasError('required')"> Reply to email is required </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always" fxFlex>
          <mat-label>Subject line</mat-label>
          <input
            matInput
            forbidAngleBrackets
            class="subject-input"
            type="text"
            formControlName="subject"
            placeholder="subject"
          />
          <mat-error *ngIf="emailForm.get('subject').hasError('required')"> Subject is required </mat-error>
        </mat-form-field>
        <div class="text-editor-container">
          <rich-text-editor [form]="emailForm" field="content" label="Message *" placeholder="message body">
          </rich-text-editor>
        </div>
        <div fxLayout="column" class="reminder-controls" *ngIf="isEmailTypeInvitee || isEmailTypeInvitees">
          <div fxLayout="row" (mouseup)="showPlanUpgradePrompt()">
            <mat-checkbox color="primary" formControlName="scheduleReminder" [disabled]="!canScheduleReminders">
              Schedule a reminder email
            </mat-checkbox>
            <mat-icon *ngIf="!canScheduleReminders" class="lock-icon">lock</mat-icon>
          </div>
          <mat-form-field
            appearance="outline"
            floatLabel="always"
            *ngIf="emailForm?.get('scheduleReminder')?.value"
            fxFlex
          >
            <mat-select formControlName="reminderDaysPreset">
              <mat-option value="2">2 days from now</mat-option>
              <mat-option value="7">7 days from now</mat-option>
              <mat-option value="14">14 days from now</mat-option>
              <mat-option value="custom">Custom</mat-option>
            </mat-select>
          </mat-form-field>
          <div
            fxLayout="row"
            fxLayoutAlign="left center"
            class="reminder-custom-days"
            *ngIf="
              emailForm?.get('scheduleReminder')?.value && emailForm?.get('reminderDaysPreset')?.value === 'custom'
            "
          >
            <mat-form-field appearance="outline">
              <input matInput type="number" min="1" formControlName="reminderDaysCustom" />
            </mat-form-field>
            <mat-label>days from now</mat-label>
          </div>
          <mat-error *ngIf="emailForm.hasError('wholeNumber')"> A whole number is required </mat-error>
          <mat-error *ngIf="emailForm.get('reminderDaysCustom').hasError('min')">
            A positive number is required
          </mat-error>
        </div>
      </div>
    </div>
  </form>
  <div class="step-buttons" fxLayout fxLayoutGap="10px">
    <div
      *ngIf="
        isEmailTypeInvitee || isEmailTypeInvitees || isEmailTypeTeamMembers || isEmailTypeSurvey || isEmailTypeTeamForm
      "
    >
      <button
        mat-raised-button
        color="primary"
        matStepperNext
        [disabled]="!stepComposeEmailValid()"
        id="compose-email-button"
      >
        Next
      </button>
      <button *ngIf="!isEmailTypeInvitee" mat-raised-button matStepperPrevious class="back-button">Back</button>
    </div>
    <preview-template-message
      class="preview-button"
      [templateName]="getTemplateName()"
      [subject]="emailForm.get('subject').value"
      [fromName]="emailForm.get('fromName').value"
      [replyTo]="emailForm.get('replyTo').value"
      [content]="emailForm.get('content').value"
      [buttonText]="getButtonText()"
      [link]="getButtonLink()"
      [personId]="this.recipientPersonId"
      [isEmailComposed]="stepComposeEmailValid()"
    >
    </preview-template-message>
  </div>
</div>
